
// search_getArrObjFreeIndex
export const search_getArrObjFreeIndex = (array, att='index') => {

    for(let i=0; i<array.length; i++){

        let found = false
        for(let j=0; j<array.length; j++){
            found = found || array[j][att] === i
        }

        if(!found)
            return i

    }

    return array.length

}

// search_getObjBiggestAttIndex_n
export const search_getObjBiggestAttIndex_n = (obj) => {

    let ans = 0;

    if(!obj) {
        return ans
    }


    for(let key in obj){
        if(obj[key] >  ans)
            ans = key
    }

    return ans

}





